import Hammer  from "hammerjs";
import {isMobileDevice} from "../imageEditor";

export default function initPanZoom({canvas: canvas, imageEditor: imageEditor}) {
    fabric.Canvas.prototype.zoomIn = function(zoom) {
        let point = new fabric.Point(this.width / 2, this.height / 2);
        let currentZoom = this.getZoom();
        this.zoomToPoint(point, currentZoom * zoom);
        canvas.fire('viewport:zoom');
    };

    $(document).ready(function() {
        canvas.zoomToMask({store: imageEditor.store, zoom: 0.6});
        canvas.fire('viewport:zoom');
    });

    if (isMobileDevice()) {
        mobileControls({canvas: canvas, imageEditor: imageEditor});
    } else {
        desktopControls({canvas: canvas, imageEditor: imageEditor})
    }
}

function mobileControls({canvas: canvas, imageEditor: imageEditor}) {
    fabric.Object.prototype.set({
        cornerSize: 30,
    });

    fabric.IText.prototype.set({
        cornerSize: 15,
    });


    let hammer = new Hammer(canvas.upperCanvasEl);

    hammer.get('pinch').set({ enable: true });
    hammer.get('pan').set({ pointers: 1 });

    function lerp(start, end, t) {
        return (1 - t) * start + t * end;
    }

    let lastScale = 1;
    let currentScale;
    hammer.on('pinchstart', function(e) {
        lastScale = canvas.getZoom();
        currentScale = lastScale * (e.scale);
        lockObjects(true);
    });

    hammer.on('pinchmove', function(e) {
        let scale = lastScale * (e.scale);
        currentScale = lerp(currentScale, scale, 0.1);

        let point = new fabric.Point(e.center.x, e.center.y);

        canvas.zoomToPoint(point, currentScale);
        canvas.fire('viewport:zoom');
    });

    hammer.on('pinchend', function(e) {
        setTimeout(()=> {
            lockObjects(false);

            canvas.forEachObject(function(obj) {
                obj.originalState = obj.toObject();
            });
        }, 100);
    });

    let lastPosX = 0;
    let lastPosY = 0;

    hammer.on('panstart', function(e) {
        if (canvas.getActiveObject()) return;

        lastPosX = canvas.viewportTransform[4];
        lastPosY = canvas.viewportTransform[5];
    });

    hammer.on('panmove', function(e) {
        if (canvas.getActiveObject()) return;

        let deltaX = e.deltaX;
        let deltaY = e.deltaY;

        let newPosX = lastPosX + deltaX;
        let newPosY = lastPosY + deltaY;

        canvas.viewportTransform[4] = newPosX;
        canvas.viewportTransform[5] = newPosY;
        canvas.fire('viewport:pan');
        canvas.requestRenderAll();
    });

    canvas.selection = false;

    let canSelect = false;
    fabric.Object.prototype.onSelect = function() {
        return !canSelect;
    }

    hammer.get('press').set({ time: 500 }); // 500 milliseconds
    let objectToSelect;
    canvas.on('mouse:down', function(event) {
        objectToSelect = event.target;
    });

    hammer.on('press', function(event) {
        if (!objectToSelect) return;

        canSelect = true;
        canvas.setActiveObject(objectToSelect);
        canvas.requestRenderAll();
        canSelect = false;
    });
}

function lockObjects(value) {
    fabric.Object.prototype.set({
        lockMovementX: value,
        lockMovementY: value,
        lockRotation: value,
        lockScalingFlip: value,
        lockScalingX: value,
        lockScalingY: value,
        lockSkewingX: value,
        lockSkewingY: value,
    });
}

function desktopControls({canvas: canvas, imageEditor: imageEditor}) {
    pan({canvas: canvas, imageEditor: imageEditor});

    canvas.on('mouse:wheel', function(opt) {
        let e = opt.e;

        var delta = e.deltaY;
        var zoom = canvas.getZoom();
        zoom *= 0.999 ** delta;
        if (zoom > 20) zoom = 20;
        if (zoom < 0.01) zoom = 0.01;
        canvas.zoomToPoint({ x: e.offsetX, y: e.offsetY }, zoom);
        canvas.fire('viewport:zoom');

        e.preventDefault();
        e.stopPropagation();
    });
}

function pan({canvas: canvas, imageEditor: imageEditor}) {
    let isWheelDown = false;
    let lastPosX, lastPosY;

    let canvasWrapper = canvas.getElement().parentElement;
    canvasWrapper.addEventListener('mousedown', function(evt) {
        if (evt.button === 1) {
            isWheelDown = true;
            lastPosX = evt.clientX;
            lastPosY = evt.clientY;
        }
    });

    document.body.addEventListener('mouseup', function(evt) {
        if (evt.button === 1) {
            isWheelDown = false;
            canvas.fire('viewport:pan_end');
        }
    });

    function handleMouseMove(opt) {
        if (!isWheelDown) {
            return;
        }

        let e = opt.e;
        let vpt = canvas.viewportTransform;
        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;
        lastPosX = e.clientX;
        lastPosY = e.clientY;
        canvas.fire('viewport:pan');
        canvas.requestRenderAll();
    }

    // FabricJS mousemove event
    canvas.on('mouse:move', handleMouseMove);
}
